__turbopack_context__.v({
  "className": "bagel_fat_one_9c020c26-module__63rXvW__className",
  "variable": "bagel_fat_one_9c020c26-module__63rXvW__variable",
});
